import { Show } from "react-admin";
import { useMediaQuery } from "@mui/material";
import { SimpleShowLayout, TextField, Labeled, ReferenceField, DateField } from "react-admin";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import BackButtonToolbar from "features/BackButtonToolbar";
import { specialistRequests } from "api/specialistApi";

const ShowPostgraduateCourses = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Show
      title="Детайли на следдипломни курсове"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <SectionTitle
              title="Основна информация"
              paddingY={0}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Тип">
              <ReferenceField
                source="typeId"
                reference={specialistRequests.getPostgraduateCourseTypesSelect()}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Номер">
              <TextField source="number" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Година">
              <TextField source="year" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име">
              <TextField source="name" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Отдел">
              <ReferenceField
                source="departmentId"
                reference={administrationRequests.getDepartmentsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Клиника">
              <TextField source="clinic" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Описание">
              <TextField source="description" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Продължителност в календарни дни">
              <TextField source="durationInCalendarDays" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Начална дата">
              <DateField
                source="startDate"
                locales="bg-BG"
                showTime
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Максимален брой участници">
              <TextField source="maxParticipants" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Бележка">
              <TextField source="note" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowPostgraduateCourses;
